import React from "react";

export function Field({
  label,
  hint,
  value,
  onChange,
  inputMode = "text",
  placeholder
}: {
  label: string;
  hint?: string;
  value: string;
  onChange: (v: string) => void;
  inputMode?: React.HTMLAttributes<HTMLInputElement>["inputMode"];
  placeholder?: string;
}) {
  return (
    <label style={{ display: "block" }}>
      <div style={{ fontSize: 13, fontWeight: 600, lineHeight: 1.5, marginBottom: 10, minHeight: 40, color: "var(--text)" }}>{label}</div>
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        inputMode={inputMode}
        placeholder={placeholder}
        style={{
          width: "100%",
          padding: "12px 12px",
          borderRadius: 12,
          border: "1px solid var(--border)",
          background: "rgba(255,255,255,0.05)",
          color: "var(--text)",
          outline: "none"
        }}
      />
      {hint ? <div style={{ marginTop: 6, fontSize: 12, color: "var(--muted)" }}>{hint}</div> : null}
    </label>
  );
}

